// extracted by mini-css-extract-plugin
export var avatar = "_k6-3";
export var avatarContainer = "_k6-2";
export var avatarSpacer = "_k6-5";
export var avatarSpacerContainer = "_k6-4";
export var avatarStackContainer = "_k6-1";
export var bubble = "_k6-0";
export var remainderBubble = "_k6-6";